import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/PlayerMatch/Get', params)
    },
    getList: params => {
        return API.GET('/api/PlayerMatch/List', params)
    },
    getTeam: params => {
        return API.GET('/api/PlayerMatch/GetTeam', params)
    },
    add: params => {
        return API.POST('/api/PlayerMatch/Add', params)
    },
    addSimple: params => {
        return API.POST('/api/PlayerMatch/AddSimple', params)
    },
    editSimple:params=>{
        return API.POST('/api/PlayerMatch/EditSimple', params)
    },
    edit: params => {
        return API.POST('/api/PlayerMatch/Edit', params)
    },
    adminAdd: params => {
        return API.POST('/api/PlayerMatch/adminAdd', params)
    },
    adminEdit: params => {
        return API.POST('/api/PlayerMatch/adminEdit', params)
    },
    approve: params => {
        return API.POSTFMT('/api/PlayerMatch/Approve', params)
    },
    cancelApprove: params => {
        return API.POSTFMT('/api/PlayerMatch/CancelApprove', params)
    },
    delete: params => {
        return API.DELETE('/api/PlayerMatch/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/PlayerMatch/DeleteBatch', params)
    }, download: params => {
        return API.GETBlog('/api/PlayerMatch/Export', params)
    },downloadMore: params => {
        return API.GETBlog('/api/PlayerMatch/ExportMore', params)
    },
    downloadPlayer: params => {
        return API.GETBlog('/api/PlayerMatch/downloadPlayer', params)
    }, total: params => {
        return API.GET('/api/PlayerMatch/Total', params)
    },
    import: params => {
        return API.POSTFORM('/api/PlayerMatch/Import', params)
    },
    importBatch: params => {
        return API.POSTFORM('/api/PlayerMatch/ImportBatch', params)
    },
    validate: params => {
        return API.POST('/api/PlayerMatch/validate', params)
    },
    validateHouseHold: params => {
        return API.POST('/api/PlayerMatch/ValidateHouseHold', params)
    }, upload: params => {
        return API.POSTFORM('/api/PlayerMatch/Upload', params)
    },
    addBatch: params => {
        return API.POSTJSON('/api/PlayerMatch/addBatch', params)
    }   
}


// WEBPACK FOOTER //
// ./src/apis/playermatch.js